<template>
  <div style="flex-direction: initial;" id="ExtFields">
    <div class="extFields-wrapper">
      <div class="head-box">
        <div @click="$router.go(-1)" class="c-pointer">
          <i class="el-icon-arrow-left m-r-5"></i>
          <span>属性管理</span>
          /
          <span>{{ ext.title }}</span>
        </div>
        <div class="c-flex">
          <el-input
            placeholder="请输入要查询的内容"
            v-model="searchValue"
            clearable
            @clear="
              fpi.page = 1;
              getData();
            "
            @keyup.enter.native="
              fpi.page = 1;
              getData();
            "
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="
                fpi.page = 1;
                getData();
              "
            ></el-button>
          </el-input>
          <el-button type="primary" @click.native="doNew" class="c-m-l-10">创建属性</el-button>
        </div>
      </div>
      <div class="content-box">
        <div class="content-table">
          <el-table
            ref="table"
            :data="fpi.data"
            style="width: 100%"
            height="calc(100% - 50px)"
            highlight-current-row
          >
            <el-table-column prop="order" label="排序" fixed width="50px"></el-table-column>
            <el-table-column label="上移" fixed width="50px">
              <div class="c_pointer c-flex" slot-scope="scope" @click="moveUp(scope)">
                <i class="el-icon-top c_size_20" style="color:#409eff;padding:4px 0 0"></i>
              </div>
            </el-table-column>
            <el-table-column label="下移" fixed width="50px">
              <div class="c_pointer c-flex" slot-scope="scope" @click="moveDown(scope)">
                <i class="el-icon-bottom c_red c_size_20" style="padding:4px 0 0"></i>
              </div>
            </el-table-column>
            <el-table-column
              prop="nameDisp"
              label="显示名称"
              width="120px"
              show-overflow-tooltip
              fixed
            ></el-table-column>
            <el-table-column prop="name" label="属性名" width="120px"></el-table-column>
            <el-table-column
              prop="type"
              label="字段类型"
              :formatter="formatType"
              width="100"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="valueOption"
              label="关联选项"
              :formatter="formatFieldType"
              width="120px"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="是否预置">
              <template slot-scope="scope">
                {{ scope.row.preset == 1 ? '系统预置' : '租户扩展' }}
              </template>
            </el-table-column>
            <el-table-column prop="required" label="是否必填">
              <template slot-scope="scope">
                {{ scope.row.required == '1' ? '是' : '否' }}
              </template>
            </el-table-column>
            <el-table-column
              prop="operationType"
              label="操作权限"
              :formatter="formatOperationType"
            ></el-table-column>
            <el-table-column
              prop="showType"
              label="是否展示"
              :formatter="formatShowType"
            ></el-table-column>
            <el-table-column
              prop="showList"
              label="展示位置"
              :formatter="formatShowList"
              width="400px"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="frontEndConfig"
              label="字段配置"
              width="150px"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="importFlag"
              label="是否支持导入"
              width="120px"
              :formatter="formatImportFlag"
            ></el-table-column>
            <el-table-column
              prop="importDistinct"
              label="新增导入是否判重"
              width="120px"
              :formatter="formatImportDistinct"
            ></el-table-column>
            <el-table-column
              prop="importSync"
              label="同步是否作为唯一判断标识"
              width="180px"
              :formatter="formatImportSync"
            ></el-table-column>
            <el-table-column prop="group" label="分组" width="50px"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="140px"></el-table-column>
            <el-table-column prop="updateTime" label="修改时间" min-width="140px"></el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              :width="permissions.isEdit ? '160px' : '160px'"
            >
              <template slot-scope="scope">
                <el-button @click.native.prevent="doEdit(scope.row)" size="mini">编辑</el-button>
                <template v-if="scope.row.state == 0">
                  <el-button
                    @click.native.prevent="doEnable(scope.row._id)"
                    type="danger"
                    size="mini"
                  >
                    已禁用
                  </el-button>
                </template>
                <template v-else>
                  <el-button
                    @click.native.prevent="doDisable(scope.row._id)"
                    type="success"
                    size="mini"
                  >
                    已启用
                  </el-button>
                </template>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="pagination"
            @size-change="pageSizeChange"
            @current-change="pageChange"
            :current-page="fpi.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="fpi.rows"
            layout="total, sizes, prev, pager, next, jumper"
            :total="fpi.total"
          ></el-pagination>
          <!-- 创建属性 -->
          <div>
            <el-dialog title="创建属性" :visible.sync="openDetail">
              <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                label-width="110px"
                label-position="left"
              >
                <el-form-item label="排序" prop="order">
                  <el-input-number
                    v-model="formData.order"
                    :min="0"
                    :controls="false"
                    placeholder="不填默认往后排"
                  ></el-input-number>
                </el-form-item>
                <el-form-item label="分组" prop="order">
                  <el-input-number
                    v-model="formData.group"
                    :min="0"
                    :precision="0"
                    :controls="false"
                    placeholder="表单分步提交的步数，不填默认为1"
                  ></el-input-number>
                </el-form-item>
                <el-form-item label="显示名称" prop="nameDisp">
                  <el-input v-model="formData.nameDisp"></el-input>
                </el-form-item>
                <el-form-item label="属性名" prop="name">
                  <el-input v-model="formData.name"></el-input>
                </el-form-item>
                <el-form-item label="字段类型" prop="type">
                  <el-select v-model="formData.type" @change="formData.valueOption = ''">
                    <el-option
                      v-for="item in options.fieldType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                      <span style="float: left">{{ item.label }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">
                        {{ item.value }}
                      </span>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="关联代码"
                  v-if="
                    formData.type == 'radio' ||
                      formData.type == 'checkbox' ||
                      formData.type == 'select' ||
                      formData.type == 'bizSelect' ||
                      formData.type == 'cascade' ||
                      formData.type == 'addItem'
                  "
                >
                  <el-select
                    filterable
                    allow-create
                    default-first-option
                    remote
                    placeholder="可输入名称搜索"
                    :remote-method="getCodeType"
                    v-model="formData.valueOption"
                    @change="$forceUpdate()"
                  >
                    <el-option
                      v-for="item in options.codeType"
                      :key="item.type"
                      :label="item.name"
                      :value="item.type"
                    >
                      <span style="float: left">{{ item.name }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">
                        {{ item.type }}
                      </span>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="是否多选"
                  prop="multiple"
                  v-if="
                    formData.type == 'select' ||
                      formData.type == 'bizSelect' ||
                      formData.type == 'cascade' ||
                      formData.type == 'request'
                  "
                  :rules="{
                    required: 'true',
                    trigger: 'change',
                    message: '请选择是否多选'
                  }"
                >
                  <div style="display:flex">
                    <el-radio v-model="formData.multiple" :label="false">单选</el-radio>
                    <el-radio v-model="formData.multiple" :label="true">多选</el-radio>
                  </div>
                </el-form-item>
                <el-form-item label="计算公式" v-if="formData.type == 'evaluate'">
                  <el-select
                    filterable
                    allow-create
                    v-model="formData.frontEndConfig"
                    clearable
                    @change="$forceUpdate()"
                  >
                    <el-option
                      v-for="item in options.script"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label-width="96px"
                  label="报单背景图片(900×565)"
                  v-if="formData.type == 'bgImage'"
                >
                  <el-upload
                    class="avatar-uploader"
                    :action="upload.url"
                    :data="upload.data"
                    :show-file-list="false"
                    :on-exceed="osg.uploadExceed"
                    :before-upload="
                      file => {
                        return osg.beforeUpload(file, 'image');
                      }
                    "
                    :on-success="onUploadsuccess"
                    :on-error="osg.uploadError"
                    :before-remove="
                      (file, fileList) => {
                        return beforeRemove(file, fileList, 'fileList');
                      }
                    "
                    :on-remove="
                      (file, fileList) => {
                        return onRemove(file, fileList, 'fileList');
                      }
                    "
                  >
                    <img
                      v-if="formData.frontEndConfig"
                      :src="JSON.parse(formData.frontEndConfig).list[0]"
                      class="avatar"
                    />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
                <el-form-item label="列宽" prop="width">
                  <el-input v-model="formData.width" placeholder="支持单位px"></el-input>
                </el-form-item>
                <el-form-item
                  label="是否预置"
                  prop="preset"
                  :rules="{
                    required: true,
                    trigger: 'change',
                    message: '请选择是否预置'
                  }"
                >
                  <div style="display:flex">
                    <el-radio v-model="formData.preset" :label="1">系统预置</el-radio>
                    <el-radio v-model="formData.preset" :label="0">租户扩展</el-radio>
                  </div>
                </el-form-item>
                <el-form-item
                  label="是否必填"
                  prop="required"
                  :rules="{
                    required: true,
                    trigger: 'change',
                    message: '请选择是否必填'
                  }"
                >
                  <div style="display:flex">
                    <el-radio v-model="formData.required" label="1">是</el-radio>
                    <el-radio v-model="formData.required" label="0">否</el-radio>
                  </div>
                </el-form-item>
                <el-form-item
                  label="操作权限"
                  prop="operationType"
                  :rules="{
                    required: true,
                    trigger: 'change',
                    message: '请选择操作权限'
                  }"
                >
                  <div style="display:flex">
                    <el-radio
                      v-model="formData.operationType"
                      v-for="(item, i) in options.operationType"
                      :key="i"
                      :label="item.value"
                    >
                      {{ item.label }}
                    </el-radio>
                  </div>
                </el-form-item>
                <el-form-item
                  label="是否展示"
                  prop="showType"
                  :rules="{
                    required: true,
                    trigger: 'change',
                    message: '请选择是否展示'
                  }"
                >
                  <div style="display:flex">
                    <el-radio-group
                      v-model="formData.showType"
                      @change="
                        formData.showField = '';
                        formData.showValue = '';
                      "
                    >
                      <el-radio :label="item.value" v-for="(item, i) in options.showType" :key="i">
                        {{ item.label }}
                      </el-radio>
                    </el-radio-group>
                  </div>
                </el-form-item>
                <el-form-item
                  label="当字段"
                  prop="showField"
                  v-if="formData.showType == '3'"
                  :rules="{
                    required: true,
                    trigger: 'blur',
                    message: '请输入'
                  }"
                >
                  <el-input
                    v-model="formData.showField"
                    placeholder="根据此字段的值展示"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="等于?时展示"
                  prop="showValue"
                  :rules="{
                    required: true,
                    trigger: 'blur',
                    message: '请输入'
                  }"
                  v-if="formData.showType == '3'"
                >
                  <el-input
                    v-model="formData.showValue"
                    placeholder="当字段值等于此值时展示"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="角色"
                  prop="roleIds"
                  :rules="{
                    required: true,
                    trigger: 'change',
                    message: '请选择'
                  }"
                  v-if="formData.showType == '4' || formData.showType == '5'"
                >
                  <el-select multiple clearable v-model="formData.roleIds" @change="$forceUpdate()">
                    <el-option
                      v-for="item in options.roles"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="展示位置"
                  prop="showList"
                  :rules="{
                    required: false,
                    type: 'array',
                    trigger: 'change',
                    message: '请选择展示位置'
                  }"
                >
                  <el-checkbox-group v-model="formData.showList">
                    <el-checkbox :label="item.value" v-for="(item, i) in options.showList" :key="i">
                      {{ item.label }}
                    </el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item
                  label="是否固定列"
                  v-if="formData.showList && formData.showList.indexOf('1') != -1"
                >
                  <el-radio v-model="formData.fixed" label="left">固定在左侧</el-radio>
                  <el-radio v-model="formData.fixed" label="right">固定在右侧</el-radio>
                  <el-radio v-model="formData.fixed" label="">不固定</el-radio>
                </el-form-item>
                <el-form-item label="跳转到详情页">
                  <el-input
                    v-model="formData.router"
                    placeholder="需要跳转到详情页，请填写详情页路由，如contact"
                  ></el-input>
                </el-form-item>
                <el-form-item label="占位符">
                  <el-input v-model="formData.placeholder" placeholder="提示文字"></el-input>
                </el-form-item>
                <el-form-item label="字段配置">
                  <el-input v-model="formData.frontEndConfig" type="textarea"></el-input>
                </el-form-item>
                <el-divider>导入配置</el-divider>
                <el-form-item
                  label="是否支持导入"
                  prop="importFlag"
                  :rules="{
                    required: true,
                    trigger: 'change',
                    message: '请选择'
                  }"
                >
                  <div style="display:flex">
                    <el-radio v-model="formData.importFlag" :label="1" @change="importFlagChange">
                      支持导入
                    </el-radio>
                    <el-radio v-model="formData.importFlag" :label="0" @change="importFlagChange">
                      不支持导入
                    </el-radio>
                  </div>
                </el-form-item>
                <el-form-item
                  v-if="formData.importFlag == 1"
                  label="是否必须导入本字段"
                  prop="importRequired"
                  :rules="{
                    required: true,
                    trigger: 'change',
                    message: '请选择'
                  }"
                >
                  <div style="display:flex">
                    <el-radio v-model="formData.importRequired" :label="1">
                      必须导入(不能为空)
                    </el-radio>
                    <el-radio v-model="formData.importRequired" :label="0">不必须导入</el-radio>
                  </div>
                </el-form-item>
                <el-form-item
                  v-if="formData.importFlag == 1"
                  label="新增导入本字段是否判重"
                  prop="importDistinct"
                  :rules="{
                    required: true,
                    trigger: 'change',
                    message: '请选择'
                  }"
                >
                  <div style="display:flex">
                    <el-radio v-model="formData.importDistinct" :label="1">
                      新增需要判重
                    </el-radio>
                    <el-radio v-model="formData.importDistinct" :label="0">不需要判重</el-radio>
                  </div>
                </el-form-item>
                <el-form-item
                  label="同步时是否作为唯一判断标识"
                  prop="importSync"
                  :rules="{
                    required: true,
                    trigger: 'change',
                    message: '请选择'
                  }"
                >
                  <div style="display:flex">
                    <el-radio v-model="formData.importSync" :label="1">是唯一判断标识</el-radio>
                    <el-radio v-model="formData.importSync" :label="0">非唯一判断标识</el-radio>
                  </div>
                </el-form-item>
                <el-form-item
                  v-if="formData.importFlag == 1"
                  label="表头名称"
                  prop="importName"
                  :rules="{
                    required: true,
                    trigger: 'change',
                    message: '默认等于字段显示名称'
                  }"
                >
                  <el-input v-model="formData.importName"></el-input>
                </el-form-item>
                <el-form-item
                  v-if="formData.importFlag == 1"
                  label="导入数据转化类型"
                  prop="importType"
                  :rules="{
                    required: true,
                    trigger: 'change',
                    message: '请选择'
                  }"
                >
                  <el-select v-model="formData.importType">
                    <el-option
                      v-for="item in options.importType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
              <div slot="footer">
                <el-button type="primary" @click="doSave">确 定</el-button>
                <el-button @click="doInit">取 消</el-button>
              </div>
            </el-dialog>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'extFields',
  data() {
    let $this = this;
    return {
      searchValue: '',
      fpi: {},
      openDetail: false,
      options: {
        codecfg_fieldType: { codeId: 'FIELD_TYPE' },
        operationType: [
          { label: '可编辑', value: '1' },
          { label: '只读', value: '2' },
          { label: '只读但允许创建', value: '3' }
        ],
        showType: [
          { label: '始终展示', value: '1' },
          { label: '有值才展示', value: '2' },
          { label: '根据其他字段展示', value: '3' },
          { label: '指定角色可见', value: '4' },
          { label: '指定角色不可见', value: '5' }
        ],
        showList: [
          { label: 'pc列表', value: '1' },
          { label: 'pc表单', value: '2' },
          { label: 'pc过滤器', value: '5' },
          { label: '小程序列表', value: '3' },
          { label: '小程序表单', value: '4' },
          { label: '小程序过滤器', value: '7' },
          { label: '小程序批量派单', value: '8' },
          { label: '属性变更记录', value: '6' },
          { label: '呼叫弹窗', value: '9' }
        ],
        is: [{ label: '是', value: '1' }, { label: '否', value: '2' }],
        codecfg_importType: { codeId: 'importType' }
      },
      //创建属性
      formData: {
        required: '0',
        showField: '',
        showValue: '',
        showList: [],
        roleIds: [],
        importSync: 0
      },
      rules: {
        //创建客户-表单校验
        colName: [{ required: true, message: '请选择分组对象', trigger: 'change' }],
        nameDisp: [
          {
            required: true,
            message: '请输入显示名称',
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: '请输入属性名',
            trigger: 'blur'
          }
        ],
        type: [{ required: true, message: '请选择显示类型', trigger: 'change' }]
      },
      //类型
      templateType: '',
      //标题
      templateTypeTitle: '',
      //权限
      permissions: {},
      // 上传图片
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: $this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false,
        limit: 1
      },
      ext: {}
    };
  },
  mounted() {
    window.$this = this;
    this.doInit();
    this.getCodeType();
    this.getExt();
    this.osg.codeoption(() => {
      // this.osg.getFpi(); //不注释会替换ext的fpi条件
      this.getData();
    });
    this.getScript();
  },
  methods: {
    formatImportFlag(row, column, cellValue) {
      return cellValue == 1 ? '支持' : '不支持';
    },
    formatImportDistinct(row, column, cellValue) {
      return cellValue == 1 ? '判重' : '不判重';
    },
    formatImportSync(row, column, cellValue) {
      return cellValue == 1 ? '是唯一判断标识' : '非唯一判断标识';
    },
    formatOperationType(row, column, cellValue) {
      return this.osg.codelabel('operationType', cellValue);
    },
    formatType(row, column, cellValue) {
      return this.osg.codelabel('fieldType', cellValue);
    },
    formatFieldType(row, column, cellValue) {
      return this.osg.codelabel('codeType', cellValue);
    },
    formatShowType(row, column, cellValue) {
      return this.osg.codelabel('showType', cellValue);
    },
    formatShowList(row, column, cellValue) {
      return this.osg.codelabelForArray('showList', cellValue);
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doEnable(id) {
      this.osg.ajax('biz/extField/enable/' + id + '.do', null, res => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax('biz/extField/disable/' + id + '.do', null, res => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doInit() {
      this.openDetail = false;

      this.formData = {
        multiple: false,
        showType: '1',
        operationType: '1',
        required: '0',
        showField: '',
        showValue: '',
        showList: ['1', '2', '4', '5', '6'],
        roleIds: [],
        extId: this.osg.param('_id'),
        colName: this.osg.param('colName'),
        importFlag: 0,
        importSync: 0
      };
      this.templateType = this.osg.param('templateType');
      switch (
        this.templateType //2,3在Workflows
      ) {
        case 'TT1':
          this.templateTypeTitle = '业务档案';
          this.permissions.isEdit = true;
          this.getExt();
          break;
        case 'TT4':
          this.templateTypeTitle = '服务步骤';
          this.permissions.isEdit = true;
          break;
        case 'TT5':
          this.templateTypeTitle = '报单配置';
          this.permissions.isEdit = false;
          this.getExt();
          break;
        default:
          this.templateTypeTitle = '扩展管理';
          this.getExt();
      }
      if (this.$refs.formData) this.$refs.formData.resetFields();
    },
    getData() {
      var params = {
        extId: this.osg.param('_id'),
        page: this.fpi.page,
        rows: this.fpi.rows,
        'in:state|array-integer#and': '0,1',
        'regex:name|string#or': this.searchValue,
        'regex:nameDisp|string#or': this.searchValue,
        sortField: 'order'
      };
      // this.osg.setFpi(params);
      this.osg.ajax(
        'biz/extField/query.do',
        params,
        res => {
          this.fpi = res;
          this.$nextTick(() => {
            this.$refs.table.doLayout();
            this.$forceUpdate();
          });
          this.getRoles();
        },
        { noload: true }
      );
    },
    getExt() {
      let _id = this.osg.param('_id');
      if (!_id) return;
      this.osg.ajax(
        'biz/ext/query.do',
        { _id },
        res => {
          this.ext = res.data[0];
        },
        {
          noload: true
        }
      );
    },
    getRoles() {
      this.osg.ajax(
        'role/query.do',
        { _all: '1', 'is:state|integer#and': 1 },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.roles = res.data;
        },
        {
          noload: true
        }
      );
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      row.showField = row.showField || '';
      row.showValue = row.showValue || '';
      row.showList = row.showList || [];
      row.roleIds = row.roleIds || [];
      row.importFlag = row.importFlag || 0;
      row.importSync = row.importSync || 0;
      this.formData = this.$util.deepCopy(row);
      this.openDetail = true;
    },
    doSave() {
      if (this.osg.validate()) {
        if (!this.formData.order && this.formData.order != 0) {
          this.formData.order = Number(this.fpi.total) ? Number(this.fpi.total) + 1 : 1;
        }
        this.formData.group = this.formData.group || 1;
        this.osg.ajax('biz/extField/upsert.do', this.formData, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    //获取代码类型
    getCodeType(query) {
      var params = {
        _all: '1',
        'is:state|integer#and': 1,
        'regex:name|string#or': query,
        'regex:type|string#or': query
      };
      this.osg.ajax('codeType/query.do', params, res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item.type;
        });
        this.options.codeType = res.data;
        this.$forceUpdate();
      });
    },
    getScript(query) {
      let params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'regex:name|string#or': query,
        'in:state|array-integer#and': '1'
      };
      this.osg.ajax('groovyScript/query.do', params, res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item._id;
        });
        this.options.script = res.data;
      });
    },
    //上传图片成功
    onUploadsuccess(response, file, fileList) {
      var frontEndConfig = {
        list: [this.osg.downloadUrl + response.key],
        css: {}
      };
      this.$set(this.formData, 'frontEndConfig', JSON.stringify(frontEndConfig));
    },
    // 上移
    moveUp(scope) {
      let row = scope.row;
      row.order = row.order - 1; // 当前行order - 1
      this.osg.ajax(
        'biz/extField/upsert.do',
        row,
        () => {
          let index = scope.$index - 1;
          let row = this.fpi.data[index];
          if (row) {
            row.order = row.order + 1; // 上一行order + 1
            this.osg.ajax(
              'biz/extField/upsert.do',
              row,
              () => {
                this.getData();
              },
              { noload: true }
            );
          } else {
            this.getData();
          }
        },
        { noload: true }
      );
    },
    // 下移
    moveDown(scope) {
      let row = scope.row;
      row.order = row.order + 1; // 当前行order + 1
      this.osg.ajax(
        'biz/extField/upsert.do',
        row,
        () => {
          let index = scope.$index + 1;
          let row = this.fpi.data[index];
          if (row) {
            row.order = row.order - 1; // 下一行order - 1
            this.osg.ajax(
              'biz/extField/upsert.do',
              row,
              () => {
                this.getData();
              },
              {
                noload: true
              }
            );
          } else {
            this.getData();
          }
        },
        { noload: true }
      );
    },
    // 切换是否导入
    importFlagChange(importFlag) {
      if (importFlag == 1) {
        this.$set(this.formData, 'importName', this.formData.nameDisp);
      } else {
        delete this.formData.importRequired;
        delete this.formData.importDistinct;
        delete this.formData.importSync;
        delete this.formData.importName;
        delete this.formData.importType;
      }
      this.$forceUpdate();
    }
  }
};
</script>
<style scoped>
.extFields-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  /*padding: 0 10px;*/
  flex: 1;
}
/**/
#ExtFields >>> .avatar-uploader .el-upload {
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 90px;
  border: 1px solid;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
/*手机模型图*/
.guise-mobile {
  background-repeat: no-repeat;
  background-size: 100%;
  width: 340px;
  height: 645px;
  position: absolute;
  left: calc(50% - 170px);
  top: 70px;
  padding: 80px 35px 90px 35px;
}
.guise-mobile-2 {
  top: 0;
  left: 0;
}
.guise-mobile-show {
  width: 100%;
  height: 91%;
  border: 1px solid #ddd;
  overflow-y: auto;
}
.div-mc {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
